/**
 * 화면의 편성 배정이 지금 **덮여 있는가** — 화면 상세의 편성 배정 칸이 말한다(2026-10-28).
 *
 * 사용자 보고: "관리 콘솔에서 화면에 편성 배정을 선택했는데 아무 동작을 안 한다" — 배정은 저장됐는데, 모든 화면을 대상으로
 * 하는 캠페인(전체 대체)이 그 위에서 이기고 있어 기기 화면이 그대로였다. 해석 순서(긴급 → 바로 보내기 → 운영 시간 → 캠페인
 * → 화면 배정)는 [편성 결정 근거] 를 열어야 보여, 배정을 고르는 자리에서는 왜 안 바뀌는지 알 길이 없었다.
 *
 * 판정은 편성 미리보기(`GET /displays/:id/preview`)의 결과로 한다 — 해석 엔진이 실제로 고른 출처다. 캠페인은 **전체 대체**일
 * 때만 덮은 것이다: 삽입(blend)이면 배정한 편성이 그대로 나가고 사이에 캠페인이 끼일 뿐이다(항목 출처가 `base` 로 섞인다).
 */
import type { DisplayPreview } from './api/client.js';

export type AssignmentOverride =
  | { kind: 'emergency' }
  | { kind: 'direct' }
  | { kind: 'closed' }
  /** `campaignId` 는 해석 기록이 가리키는 캠페인 — 이름을 찾아 보이고 그 캠페인으로 이끈다. */
  | { kind: 'campaign'; campaignId: string | null };

export function assignmentOverride(preview: Pick<DisplayPreview, 'source' | 'items' | 'trace'> | null | undefined): AssignmentOverride | null {
  if (!preview) return null;
  switch (preview.source) {
    case 'emergency':
      return { kind: 'emergency' };
    case 'direct':
      return { kind: 'direct' };
    case 'closed':
      return { kind: 'closed' };
    case 'campaign': {
      // 삽입이면 배정한 편성의 항목(`base`)이 함께 나간다 — 덮인 것이 아니다.
      if (preview.items.some((item) => item.origin === 'base')) return null;
      const entry = preview.trace.find((step) => step.stage === 'campaign' && step.matched);
      return { kind: 'campaign', campaignId: entry?.ref ?? null };
    }
    default:
      return null;
  }
}
